<template>
  <div>
      <div class="page-header">
              <h1>
                Garage Door Torsion Springs
              </h1>
            </div>
            <div class="block block-border-bottom-grey block-pd-sm">
              
              <div class="row">
                <div class="col-md-8">
                  <img src="../assets/img/showcase/garage-door-torsion-spring.png" alt="garage door torsion spring" class="img-responsive img-thumbnail no-border m-b">
                </div>
                <div class="col-md-4">
                  <h4 class="block-title">
                    Manufacturing capabilities
                  </h4>
                  <ul class="manufacturing-capabilities">
                    <li>Standard oil-tempered and galvanized wire diameters in stock up to .625”</li>
                    <li>Inside diameters up to 7.625”</li>
                    <li>Overall lengths up to 144”</li>
                    <li>Manufacture rolling steel door spring</li>
                    <li>Supply stationary and winding cones</li>
                    <li>Heat applied black coating applied after stress relieving process</li>
                    <li>Ability to shot peen to improve fatigue life</li>
                    <li>Custom stenciling</li>
                    <li>Custom ends available</li>
                    <li>Custom packaging upon request</li>
                  </ul>
                </div>
                
              </div>
              <div class="row">
                <div class="col-md-8 col-xs-12">
                  <p class="iso-footer">
                    We are an ISO 9001 certified manufacturer of garage door springs. We supply to certified garage door dealers, wholesalers,
                    and manufacturers.
                  </p>
                </div>
              </div>
            </div>
          </div>
</template>

<script>
export default {
  name: "GarageDoorSpringsTorsion"
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/GarageDoorSpringsTorsion.vue